import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Auth.css';
import { config } from '../config';
const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(config.endpoints.users.token, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`,
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.access_token);
        
        // 获取用户信息并存储 user_id
        const userResponse = await fetch(config.endpoints.users.me, {
          headers: {
            'Authorization': `Bearer ${data.access_token}`
          }
        });
        
        if (userResponse.ok) {
          const userData = await userResponse.json();
          localStorage.setItem('user_id', userData.user_id.toString());
          navigate('/apps');
        } else {
          throw new Error('获取用户信息失败');
        }
      } else {
        // 处理错误
        alert('登录失败，请检查用户名和密码');
      }
    } catch (error) {
      console.error('登录错误:', error);
      alert('登录过程中发生错误');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>欢迎回来</h1>
        <p>登录以继续</p>
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="text"
              placeholder="输入邮箱地址"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="输入密码"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="auth-button">
            登录
          </button>
        </form>
        <div className="auth-footer">
          <a href="/forgot-password">忘记密码?</a>
          <a href="/register">注册账号</a>
        </div>
      </div>
    </div>
  );
};

export default Login; 